export const T = {
  en_GB: {
    verifiedId: "ID verified",
    testMode: "Test",
  },
  nb_NO: {
    verifiedId: "ID verifisert",
    testMode: "Test",
  },
} as const;
